import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';

export const requiredFilterSectionStyle = {
    borderLeft: '4px solid #2185d0',
    background: '#ffffff',
    boxShadow: 'none',
    marginBottom: '16px'
};

export const additionalFilterSectionStyle = {
    background: '#ffffff',
    boxShadow: 'none',
    marginBottom: '16px'
};

export const compactAdditionalFilterSectionStyle = {
    ...additionalFilterSectionStyle,
    maxWidth: '720px'
};

export const checkboxFieldStyle = {
    display: 'flex',
    alignItems: 'center',
    minHeight: '38px'
};

export const filterFieldGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    columnGap: '1rem',
    rowGap: '1rem',
    alignItems: 'end'
};

export const isStudentServiceRole = activeRole => (activeRole || '').substr(0, 10) === 'Studentska';

export const isViceDeanForEducationRole = activeRole => (activeRole || '').substr(0, 19) === 'Prodekan za nastavu';

export const isFacultyScopedStudentReportRole = activeRole =>
    isStudentServiceRole(activeRole) || isViceDeanForEducationRole(activeRole);

export const shouldShowOrgUnitFilter = activeRole => !isFacultyScopedStudentReportRole(activeRole);

const studentIndicatorWrapperStyle = {
    float: 'right',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    marginLeft: '8px'
};

export const renderStudentIndicators = (student) => (
    <span style={studentIndicatorWrapperStyle}>
        {student.droppedOut && (
            <Popup
                trigger={<Icon name="sign-out" color="red" />}
                content="Student je ispisan"
                on="hover"
                hideOnScroll
                position="top center"
            />
        )}
        {student.switchedToNewStudyProgram && (
            <Popup
                trigger={<Icon name="exchange" color="blue" />}
                content="Student je prešao na drugi studijski program"
                on="hover"
                hideOnScroll
                position="top center"
            />
        )}
    </span>
);



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/reportUiHelpers.js